import React, { useContext } from "react";
import { ChevronLeft } from "react-feather";
import styled, { ThemeContext } from "styled-components/macro";

import CustomBreadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { useBreakpoint } from "../../utilities/media-js-breakpoints";

const StyledSideMenuBackButton = styled.div`
    ${({ theme }) => theme.bp.xs`
        height: 20px;
    `};

    ${({ theme }) => theme.bp.sm`
    height: auto;
`};
    ${({ theme }) => theme.bp.md`
    height: auto;
    padding: 0;
`};
    display: flex;
    font-size: ${props => props.theme.subheader.fontSize};
    align-items: center;
`;

const ChevronContainer = styled.div`
    cursor: pointer;
    background: rgba(255, 255, 255, 1);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease-in-out;

    @media (hover) {
        &:hover {
            background: ${props => props.theme.sideMenu.chevron.hoverColor};
        }
        &:active {
            background: ${props => props.theme.sideMenu.chevron.activeColor};
        }
    }
`;

export const SideMenuBackButton = ({ goBackSideMenu }: { goBackSideMenu: (event: any) => void }) => {
    const theme = useContext(ThemeContext);
    const breakpoints = useBreakpoint();
    const isMobile = breakpoints.xxs || breakpoints.xs || breakpoints.sm;

    return (
        <StyledSideMenuBackButton aria-hidden="true">
            <ChevronContainer onClick={goBackSideMenu}>
                <ChevronLeft size={28} color={theme.sideMenu.backButton.color} />
            </ChevronContainer>
            {!isMobile ? <CustomBreadcrumbs goBackSideMenu={goBackSideMenu} /> : null}
        </StyledSideMenuBackButton>
    );
};
